export default "__VITE_ASSET__DaVSBed6__"